import zhtw from '@/i18n/zhtw.json';
import cn from '@/i18n/cn.json';
import en from '@/i18n/en.json';

const messages = {
  zhtw,
  cn,
  en,
};

const LICENSE_CODE_PATTERN = /LICENSE_CODE_\d{4}/;

/** 錯誤代碼-正則表達式 */
const ERROR_CODE_PATTERN = /AUTH_CODE_407|LICENSE_CODE_\d{4}/;

const getCurrentLang = () => {
  const lang =
    sessionStorage.getItem('userLang') ||
    sessionStorage.getItem('setLang') ||
    window.$i18n?.locale?.value ||
    'zhtw';

  return messages[lang] ? lang : 'en';
};

export const getLicenseErrorCode = (message) => {
  if (typeof message !== 'string') return '';
  return message.match(LICENSE_CODE_PATTERN)?.[0] || '';
};

/**
 * 從訊息中取得錯誤代碼
 * @param {*} message
 * @returns
 */
const getAuthOrLicenseErrorCode = (message) => {
  if (typeof message !== 'string') return '';
  const matchResult = message.match(ERROR_CODE_PATTERN)?.[0] || '';
  return matchResult;
};

/**
 * 從不同的錯誤訊息格式中選一個有的訊息
 * @param {*} error
 * @returns
 */
export const getErrorResponseMessage = (error) => {
  return error?.response?.data?.msg || error?.data?.msg || error?.message || error;
};

/**
 * 依照參數取得錯誤代碼
 * @param {*} error
 * @returns
 */
export const getAuthOrLicenseResponseCode = (error) => {
  return getAuthOrLicenseErrorCode(getErrorResponseMessage(error));
};

/**
 * 依照語系取得授權錯誤之訊息
 * @param {*} message
 * @param {*} lang
 * @returns
 */
export const getLocalizedAuthOrLicenseMessage = (message, lang = getCurrentLang()) => {
  const errorCode = getAuthOrLicenseErrorCode(message);

  if (!errorCode) return '';

  const errorMessages =
    messages[lang]?.As_5?.license_errors ||
    messages.zhtw.As_5.license_errors ||
    messages.en.As_5.license_errors;

  return errorMessages[errorCode] || messages.en.As_5.license_errors[errorCode] || '';
};

/**
 * 從驗證授權結果訊息轉換成語系文字
 * @param {*} error
 * @returns
 */
export const getLocalizedAuthOrLicenseResponseMessage = (error) => {
  return getLocalizedAuthOrLicenseMessage(getErrorResponseMessage(error));
};

/**
 * 判斷「某個 API error 是否來自 license 相關 API」
 * @param {*} error
 * @returns
 */
export const isLicenseApiRequest = (error) => {
  const url = error?.config?.url || error?.response?.config?.url || '';
  return /\/license(?:Info)?(?:[?#]|$)/i.test(url);
};
